export default {
    "ARTIST": {
        "ARTIST": "Előadó",
        "ARTISTS": "Előadók",
        "NAME": "Név",
        "CATEGORY": "Kategória",
        "CATEGORIES": "Kategóriák",
        "FB_ID": "Facebook ID",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/hu/artist.js